<template>
    <div v-if="coffeesData && coffeesData.length" class="padded">
        <carousel
            v-for="(row, i) in Math.ceil(coffeesData.length / maxCardsPerRow)"
            v-bind="carouselOptions(true)"
            :key="i"
            class="carousel">

            <slide v-for="(coffee, index) in coffeesData.slice(i * maxCardsPerRow, Math.min((i + 1) * maxCardsPerRow), coffeesData.length - 1)" v-if="coffee" :key="coffee.id">

                <div v-on:click="$emit('selected', coffee.id)">
                    <p v-if="deliveredAtHash" class="font-xs red-font align-center">
                        delivered on: {{ formatDate(deliveredAtHash[coffee.id]) }}
                    </p>
                    <coffee-card-base
                        :coffee="coffee"
                        :show="!removedCoffees.includes(coffee.id)"
                        :disable-link="disableLink"
                        :style="{ 'background-color': '#FFFFFF' }"
                        :class="{ 'selected-card': selectedCoffees && selectedCoffees.includes(coffee.id) }"
                        :key="coffee.id" >

                        <!-- Coffee Ratings -->
                        <coffee-rating-card
                            v-if="ratings"
                            :coffee="coffee"
                            :totalRatings="ratings[coffee.id].total"
                            :key="coffee.id"
                            @remove="removeCard"
                        />

                        <!-- Add to Playlist -->
                        <playlist-coffee-card
                            v-else-if="isAdmin"
                            :coffee="coffee"
                            :playlists="getAvailablePlaylists(playlists, coffee.id)"
                            :background-color="'#FFFFFF'"
                            :addedPlaylistIdsProp="getAddedPlaylistIds(coffee.id)"
                            :numRequests="requests.filter(r => r.product_id === coffee.id).length"
                            :products="products"
                            :product-sizes="customSizes"
                            :requestdetails="requestdetails"
                            :requests="requests"
                            :tax-rate="taxRate"
                            :cId="coffee.id"
                            :key="coffee.id"
                        />

                        <!-- Coffee Requests -->
                        <coffee-request-card
                            v-else-if="requests"
                            :coffee="coffee"
                            :playlists="getAvailablePlaylists(playlists, coffee.id)"
                            :background-color="'#FFFFFF'"
                            :requestedPlaylistIdsProp="requests.filter(r => r.product_id === coffee.id).map(r => r.workplace_playlist_id)"
                            :key="coffee.id"
                        />
                    </coffee-card-base>
                </div>

            </slide>
        </carousel>
    </div>
</template>

<script>
    import CoffeeMixin from '../../mixins/coffee-mixin';
    import DateMixin from '../../mixins/date-mixin'
    import CoffeeCardBase from './coffee-card-base';
    import CoffeeRatingCard from './coffee-rating-card';
    import CoffeeRequestCard from './coffee-request-card';
    import PlaylistCoffeeCard from './playlist-coffee-card';
    import {Carousel, Slide} from "vue-carousel";

    export default {
        components: {
            CoffeeCardBase,
            CoffeeRatingCard,
            CoffeeRequestCard,
            PlaylistCoffeeCard,
            Carousel,
            Slide
        },
        props: {
            requests: Array,
            ratings: Object,
            products: Array,
            customSizes: Array,
            requestdetails: Array,
            coffees: Array,
            selectedCoffees: Array,
            disableLink: Boolean,
            deliveredAtHash: Object,
            playlists: Array,
            maxCardsPerRow: {
                type: Number,
                default: 9
            },
            isAdmin: {
                type: Boolean,
                default: false
            },
            backgroundColorOffset: {
                type: Number,
                default: 0
            },
            taxRate: Number
        },
        data: function () {
            return {
                coffeesData: undefined,
                removedCoffees: []  
            }
        },
        methods: {
            removeCard(coffeeId) {
                this.removedCoffees.push(coffeeId);

                // Wait until animation ends
                setTimeout(() => {
                    this.coffeesData = this.coffeesData.filter(c => c.id != coffeeId);
                    if (this.coffeesData.length === 0) {
                        this.$emit('is-empty')
                    }
                }, 2000);
            },
            getAvailablePlaylists(playlists, coffeeId) {
                return playlists.filter(p => p.all_active_product_ids)
            },
            getAddedPlaylistIds(coffeeId) {
                // TODO: Better aggregation should be done on the Backend to avoid this nasty conversions
                const addedPlaylists = this.playlists.filter(p => p.workplace_playlist_products.find(pp => pp.product_id === coffeeId));
                return addedPlaylists.map(p => p.id);
            },
            getBackgroundColorOffset(row) {
                const factor = 5;
                return (this.backgroundColorOffset * factor) + (row * factor);
            }
        },
        watch: {
            coffees: function() {
                this.coffeesData = this.coffees;
            }
        },
        mounted: function() {
            this.coffeesData = this.coffees;
        },
        mixins: [
            CoffeeMixin,
            DateMixin
        ]
    }
</script>

<style>
    .carousel:not(:first-child) {
        margin-top: 3rem;
    }
    .selected-card {
        background-color: rgba(225, 95, 96, 0.44) !important;
    }
    .selected-card * {
        opacity: 0.6;
    }
    .VueCarousel-dot-container {
        margin: 0 !important;
    }
    .VueCarousel-navigation--disabled {
        opacity: 0 !important;
    }
    .VueCarousel-dot:focus {
        outline: none !important;
    }

    .VueCarousel-navigation-prev, .VueCarousel-navigation-next {
        top: 43% !important;
        font-size: 28px;
        color: #E15F60 !important;
    }
    .VueCarousel-wrapper{
        padding-bottom: 40px;
    }
</style>
